import { gql } from 'apollo-boost';

export const CANCEL_MY_DATA_EXPORT = gql`
    mutation CancelMyDataExport {
        cancelMyDataExport {
            id
            status
            cancelledAt
            error
            createdAt
        }
    }
`;
